import { Component, Input, Output, EventEmitter } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { TicketService } from 'src/app/private/services/tickets.service';
import { LocalStorageService } from 'src/app/utils/LocalStorageService';
import { SharedModule } from 'src/app/private/shared/shared.module'; 

@Component({
  selector: 'app-bulk-action',
  templateUrl: './bulk-action.component.html',
  styleUrls: ['./bulk-action.component.scss'],
  imports: [SharedModule]
})
export class BulkActionComponent {
  @Input() selectedTickets: any[] = [];
  @Input() users: any[] = [];

  @Output() closeDialog = new EventEmitter();
  @Output() reload = new EventEmitter();

  bulkTicketForm: FormGroup;
  btnLoading = false;
  totalTickets = 0;

  ticketStatusOptions = ["New", "Open", "In Progress", "On Hold", "Esclated", "Resolved", "Closed", "Canceled", "Draft", "Reopened", "Deleted"];
  priorityOptions = ['Low', 'Medium', 'High'];
  sourceOptions = ['Tina', 'Email', 'Call', 'Web'];

  constructor(
    private fb: FormBuilder,
    private messageService: MessageService,
    private api: TicketService,
    private localStorage: LocalStorageService
  ) {
    this.bulkTicketForm = this.fb.group({
      ticket_status: [''],
      ticket_desc: [''],
      source: [''],
      priority: [''],
      assign_to: [null]
    });
  }

  ngOnInit() {
    this.totalTickets = this.selectedTickets?.length || 0;
  }

  handleCloseDialog() {
    this.closeDialog.emit();
  }

  onSubmit() {
    
    // if all fields are empty, show error
    if (Object.values(this.bulkTicketForm.value).every(value => !value)) {
      this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Please fill at least one field' });
      return;
    }

    const formValues = this.bulkTicketForm.value;

    const payload = this.selectedTickets.map(ticket => ({
      ...ticket,
      ticket_status: formValues.ticket_status || ticket.ticket_status,
      ticket_desc: formValues.ticket_desc || ticket.ticket_desc,
      source: formValues.source || ticket.source,
      priority: formValues.priority || ticket.priority,
      assign_to: formValues.assign_to || ticket.assign_to,
      campus_id: this.localStorage.getCampusId() || ticket.campus_id,
      updated_by: {
        user_id: this.localStorage.getUserId(),
        name: this.localStorage.getUserFullName(),
        email: this.localStorage.getEmail()
      },
      assignee_detail: {
        assignee_id: formValues.assign_to,
        name: this.users.find(u => u.value === formValues.assign_to)?.label || '',
        email: '' // Add if you have email in users
      }
    }));

    this.btnLoading = true;

    this.api.updateMultipleTicket(payload).subscribe({
      next: () => {
        this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Tickets updated successfully' });
        this.reload.emit();
        this.handleCloseDialog();
        this.btnLoading = false;
      },
      error: () => {
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to update tickets' });
        this.btnLoading = false;
      }
    });
  }
}
